module.exports = __webpack_public_path__ + "a4b857c9bd3c5dec25b11bd361f94c4a.svg";